// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"LegendTitle_titleWrapper__18cFK","title":"LegendTitle_title__3UAO3"};